"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Youtube, Mail, Phone, MapPin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="space-y-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-4 w-24 bg-muted animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="space-y-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-primary transition-colors font-default uppercase tracking-wider">Home</Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-muted-foreground hover:text-primary transition-colors font-default uppercase tracking-wider">Contact</Link>
        </li>
      </ul>;
  }
  return <ul className="space-y-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-primary transition-colors font-default uppercase tracking-wider">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
const socialLinks = [{
  icon: Facebook,
  href: "#",
  label: "Facebook"
}, {
  icon: Twitter,
  href: "#",
  label: "Twitter"
}, {
  icon: Instagram,
  href: "#",
  label: "Instagram"
}, {
  icon: Youtube,
  href: "#",
  label: "Youtube"
}];
const careGuides = [{
  label: "Neuro-Sensory Training",
  path: "#"
}, {
  label: "Movement Assessment",
  path: "#"
}, {
  label: "One-on-One Treatment",
  path: "#"
}];
export default function Footer() {
  return <section data-section-id="264936" id="footer" className="bg-background border-t border-border pt-16 pb-8 text-sm font-sans text-foreground">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <WvcLogo className="h-12 w-auto" />
            </Link>
            <p className="text-muted-foreground mb-6 leading-relaxed font-default">
              Tulsa Pain & Performance offers elite neuro-sensory training and movement assessment to help athletes reduce pain and boost performance.
            </p>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={i} to={social.href} aria-label={social.label} className="flex items-center justify-center size-8 rounded-md bg-muted text-muted-foreground hover:bg-primary hover:text-primary-foreground transition-all duration-300" data-index={i}>
                    <Icon className="size-4" />
                  </Link>;
            })}
            </div>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-base mb-6 text-foreground uppercase tracking-widest">Company</h3>
            <MenuProvider menu_id="footer_menu">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-base mb-6 text-foreground uppercase tracking-widest">Services</h3>
            <ul className="space-y-3">
              {careGuides.map((guide, i) => <li key={i} data-index={i}>
                  <Link to={guide.path} className="text-muted-foreground hover:text-primary transition-colors font-default uppercase tracking-wider">
                    {guide.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-base mb-6 text-foreground uppercase tracking-widest">Contact Us</h3>
            <ul className="space-y-4 mb-8">
              <li className="flex items-start gap-3 text-muted-foreground font-default" data-index={0}>
                <MapPin className="size-4 mt-0.5 shrink-0 text-primary" />
                <span>Tulsa, Oklahoma</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-default" data-index={1}>
                <Phone className="size-4 shrink-0 text-primary" />
                <span>(918) 555-0123</span>
              </li>
              <li className="flex items-center gap-3 text-muted-foreground font-default" data-index={2}>
                <Mail className="size-4 shrink-0 text-primary" />
                <span>info@tulsapainperformance.com</span>
              </li>
            </ul>
            
            <h3 className="font-default font-bold text-base mb-4 text-foreground uppercase tracking-widest">Legal</h3>
            <ul className="space-y-3 flex flex-col">
              <li data-index={0}>
                <Link to="#" className="text-muted-foreground hover:text-primary transition-colors font-default uppercase tracking-wider">Privacy Policy</Link>
              </li>
              <li data-index={1}>
                <Link to="#" className="text-muted-foreground hover:text-primary transition-colors font-default uppercase tracking-wider">Terms of Service</Link>
              </li>
            </ul>
          </div>

        </div>

        {}
        <div className="mt-16 pt-8 border-t border-border flex flex-col items-center gap-6 text-muted-foreground">
          <div className="flex items-center gap-4 w-full">
            <div className="h-px bg-border flex-1"></div>
            <p className="font-default font-bold italic text-primary tracking-widest text-center whitespace-nowrap">
              REDUCE PAIN. BOOST PERFORMANCE.
            </p>
            <div className="h-px bg-border flex-1"></div>
          </div>
          <div className="flex flex-col md:flex-row justify-between items-center w-full gap-4">
            <p className="font-default">© {new Date().getFullYear()} Tulsa Pain & Performance. All rights reserved.</p>
            <p className="text-xs font-default uppercase tracking-widest">Precision Movement & Neuro-Sensory Training</p>
          </div>
        </div>
      </div>
    </section>;
}